import { Injectable } from '@angular/core';
import * as THEMES from '../../@theme/themes';
import * as _ from 'lodash';
import cssVars from 'css-vars-ponyfill';


@Injectable({
    providedIn: 'root',
  })
export class ThemeSwitcherService {

    private currentTheme;
    constructor() {

    }

    changeTheme(theme) {
        const stylesheet: any = this.getStylesheet(theme);
        cssVars({
            shadowDOM: true,
            onlyLegacy: false,
            variables: stylesheet,
            watch: true
        });
        this.currentTheme = theme;
    }

    getStylesheet(theme) {
        return THEMES[theme];
    }

    getCurrentTheme() {
        return THEMES[this.currentTheme];
    }
}